import React from 'react';
import './App.css';
import {Nav, NavItem, NavLink, TabContent, TabPane} from "reactstrap";
import Home from "./Home/Home.mjs";
import AddToHomeScreen from "../controls/AddToHomeScreen.mjs";
import AutoIcon from "../controls/AutoIcon.mjs";
import MobileHowTo from "./MobileHowTo.mjs";
import { Glob as G } from "../libs/Glob.mjs";
import Details from "./Details/Details.mjs";
import AppBachecaIcon from "../media/assets/AppBachecaIcon.mjs";
import Bacheca from "./Bacheca/Bacheca.mjs";

const updateInterval = 30000;

const App = class extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			tab: G.getCurrentPage()?.name,
			lan: G.prop.isLAN,
			wan: ! G.prop.isLAN,
			app: G.prop.isRunningInApp,
			version: G.getAppVersion(),
			canBacheca: true,
		}
		this.uid= G.generateUid('App');
		this.update = this.update.bind(this);
		this.keyWasPressed = this.keyWasPressed.bind(this);
	}
	componentDidMount() {
		this.update();
		const isMobile = (parseInt(window.innerWidth) < 640);
		document.body.classList.toggle('mobile', isMobile);
		document.body.classList.toggle('desktop', !isMobile);
		G.register('windowResized', (w) => {
			const isMobile = (w.width < 640);
			document.body.classList.toggle('mobile', isMobile);
			document.body.classList.toggle('desktop', !isMobile);
		}, this.uid)
		G.register( 'currentPage', mo => {
			if ( mo?.name ) this.setState({ tab: mo.name });
		}, this.uid);
		window.document.addEventListener("keydown", this.keyWasPressed, false);
	}
	componentWillUnmount() {
		G.deregister( this.uid );
		window.document.removeEventListener("keydown", this.keyWasPressed, false);
	}
	update() {
		G.setStatus('appPulse', (new Date()).getTime() );
		setTimeout( this.update, updateInterval );
	}
	keyWasPressed( evt ) {
		if ( evt.key === 'Escape' ) {
			G.trigger('EscapeKeyWasPressed', true);
		}
	}
	render() {
		return (
			<>
				<div
					className={"App"}
					id={this.uid}
				>
					<span className={"AppVersion"}>
						{ this.state.version }
					</span>
					<Nav tabs>
						<NavItem>
							<NavLink
								active={ this.state.tab === 'Home' }
								onClick={ ()=>{ G.gotoPage('Home') } }
							>
								<AutoIcon value={"home"} />
							</NavLink>
						</NavItem>
						<NavItem>
							<NavLink
								active={ this.state.tab === 'Details' }
								onClick={ ()=>{ G.gotoPage('Details') } }
							>
								<AutoIcon value={"list"} />
							</NavLink>
						</NavItem>
						{ this.state.canBacheca && (
							<NavItem>
								<NavLink
									active={ this.state.tab === 'Bacheca' }
									onClick={ ()=>{ G.gotoPage('Bacheca') } }
								>
									<AppBachecaIcon />
								</NavLink>
							</NavItem>
						)}
						{ ! this.state.app && (
							<NavItem>
								<NavLink
									active={ this.state.tab === 'MobileHowTo' }
									onClick={ ()=>{ G.gotoPage('MobileHowTo') } }
								>
									<AutoIcon value={"mobile"} />
								</NavLink>
							</NavItem>
						)}
					</Nav>
					<TabContent activeTab={ this.state.tab }>
						<TabPane tabId={'Home'}>
							{ this.state.tab === 'Home' ? <Home /> : ''}
						</TabPane>
						<TabPane tabId={'Details'}>
							{ this.state.tab === 'Details' ? <Details /> : ''}
						</TabPane>
						<TabPane tabId={'Bacheca'}>
							{ this.state.tab === 'Bacheca' ? <Bacheca /> : ''}
						</TabPane>
						<TabPane tabId={'MobileHowTo'}>
							{this.state.tab === 'MobileHowTo' ? <MobileHowTo /> : '' }
						</TabPane>
					</TabContent>
				</div>
				<AddToHomeScreen />
			</>
		)
	}
}


export default App;
